import React from "react";
import { Button as MuiButton } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0.5),
  },
  label: {
    textTransform: "none",
  },
}));

export default function Button(props) {
  const { t } = useTranslation();
  const {
    text,
    size,
    color,
    variant,
    startIcon,
    onClick,
    className,
    disabled,
    component,
  } = props;
  const classes = useStyles();

  return (
    <MuiButton
      variant={variant || "outlined"}
      size={size || "large"}
      color={color || "primary"}
      onClick={onClick}
      disabled={ disabled}
      component={component}
      startIcon={startIcon}
      className={className}
    >
      {text}
      {component == null ? "" : t("uploadFile")}
    </MuiButton>
  );
}
